import { BaseIcon, BaseIconProps } from './BaseIcon';

export const TrendingUpGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="trendingUpGrad" {...props}>
    <path 
      d="M22 7l-8.5 8.5-5-5L2 17M16 7h6v6" 
      stroke="url(#trendingUpGrad)" 
    />
  </BaseIcon>
);
